<template>
	<div>
		<b-overlay :show="loading" no-wrap></b-overlay>
		<slot name="title"></slot>
		<section v-if="!$root.isEmpty(messageId)">
			<b-table
			small
			responsive="sm"
			stacked="sm"
			striped
			hover
			:fields="columns"
			:items="items"
			show-empty
			>
				<template></template>
			</b-table>
		</section>
	</div>
</template>

<script>
  export default {
    props: {
      messageId: String
    },
	data(){
		return {
			loading:false,
			items:[],
			columns:[
				{'key':'from', 'label':'Remitente'},
				{'key':'email', 'label':'Destinatario'},
				{'key':'event', 'label':'Evento'},
				{'key':'link', 'label':'Link Click'},
				{'key':'date', 'label':'Fecha y hora del evento'},
				{'key':'subject', 'label':'Asunto'},

			],
		}
	},
    computed: {
    },
    methods: {
		getLogs(){
			this.loading=true;
			this.$root.api.post(`mails/events`,{messageId:this.messageId})
			.then((res) => {
				this.items = res.data;
			})
			.catch(this.$root.handleRequestError)
			.finally(()=>{
				this.loading=false;
			})

		}
    },
	mounted(){
		this.getLogs();
	}

  }
</script>

